import { useSelector } from 'react-redux';
import type { ReactNode } from 'react';
import {
  useLocation,
  Navigate,
} from 'react-router';

interface EnsureRoleRouteProps {
  roles?: string | string[];
  children?: ReactNode;
}

export function EnsureRoleRoute({
  roles,
  children,
}: EnsureRoleRouteProps) {
  const isLoggedIn = useSelector((state: { auth: { isLoggedIn: boolean } }) => state.auth.isLoggedIn);
  const userInfo = useSelector(
    (state: { auth: { userInfo: { role?: string; isAdmin?: boolean; isStaff?: boolean; isSalesperson?: boolean } } }) => state.auth.userInfo,
  );
  const location = useLocation();

  const roleArray: string[] = Array.isArray(roles) ? roles : (roles ? [roles] : []);

  if (!roleArray.length) {
    // no need to authenticate
    return children;
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (roleArray.includes(userInfo.role as string)) {
    return children;
  }

  const dest = (userInfo.isAdmin || userInfo.isStaff || userInfo.isSalesperson)
    ? '/management'
    : '/';

  return <Navigate to={dest} replace />;
}

interface EnsureSubscriptionComponentProps {
  addonId: number | string;
  alsoEnsure?: boolean;
  children?: ReactNode;
}

export function EnsureSubscriptionComponent({
  addonId,
  alsoEnsure = true,
  children,
}: EnsureSubscriptionComponentProps) {
  if (!alsoEnsure) {
    return null;
  }

  const allowed = window.subscriptions.available[addonId];
  if (!allowed) {
    return null;
  }

  return children;
}
